import React from 'react';
import { Modal, Form, Button, ListGroup, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useUploadByRecordValue } from 'hooks/useHandleS3File';
const DocumentBaseModal = ({
  isShow,
  handleClose,
  onSubmit,
  app,
  recordValue,
  trainee,
  documentFolderParam,
  title
}) => {
  const {
    selectedFile,
    uploadedFiles,
    isLoading,
    fileInputRef,
    itemDownLoading,
    itemDeleting,
    handleFileChange,
    handleUpload,
    onFileDownload,
    onFileDelete,
    onFilePrint
  } = useUploadByRecordValue(documentFolderParam, recordValue, app, trainee);

  return (
    <Modal show={isShow} onHide={handleClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          // closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          {/* File Upload Section */}

          <Form.Group className="mb-3" controlId="fileInput">
            <Form.Label className="fs-0 required">Upload File</Form.Label>
            <Form.Control
              type="file"
              name="file"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
            {isLoading ? (
              <Spinner
                variant="primary"
                animation="border"
                role="status"
              ></Spinner>
            ) : (
              <Button
                variant="secondary"
                onClick={handleUpload}
                className="mt-2"
                disabled={!selectedFile}
              >
                Upload
              </Button>
            )}
          </Form.Group>

          {/* Uploaded Files List */}
          {uploadedFiles && uploadedFiles.length > 0 && (
            <Form.Group className="mb-3">
              <Form.Label className="fs-0">Uploaded Files</Form.Label>
              <ListGroup>
                {uploadedFiles.map((file, index) => (
                  <ListGroup.Item
                    key={index}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>{file.name}</span>

                    <div className="d-flex align-items-center">
                      {itemDeleting == index ? (
                        <Spinner
                          variant="primary"
                          animation="border"
                          role="status"
                          className="me-2"
                        />
                      ) : (
                        <Button
                          variant="danger"
                          size="sm"
                          className="me-2"
                          onClick={() => onFileDelete(index)}
                        >
                          Delete
                        </Button>
                      )}
                      {itemDownLoading == index ? (
                        <Spinner
                          variant="primary"
                          animation="border"
                          role="status"
                          className="me-2"
                        />
                      ) : (
                        <Button
                          variant="primary"
                          size="sm"
                           className="me-2"
                          onClick={() => onFileDownload(index)}
                        >
                          Download
                        </Button>
                      )}

                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => onFilePrint(index)}
                      >
                        Print
                      </Button>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Form.Group>
          )}
        </Modal.Body>
      </Form>
    </Modal>
  );
};
DocumentBaseModal.propTypes = {
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  onSubmit: PropTypes.func,
  skillLevelId: PropTypes.number.isRequired,
  sectionId: PropTypes.number.isRequired,
  app: PropTypes.string,
  recordValue: PropTypes.string,
  trainee: PropTypes.string,
  documentFolderParam: PropTypes.string,
  title: PropTypes.string,
  areaId: PropTypes.number.isRequired
};

export default DocumentBaseModal;
